import React from 'react';
import { withInject } from '@piwikpro/platform';
import { Preloader } from '@piwikpro/ui-components';

/** ChangePlanOverlay host (used by secured /payment and /payment/success). */
export const PaymentRoute = withInject({
  config: 'config',
  ChangePlanOverlay: 'MarketingCrate.components.ChangePlanOverlay',
})(({ config, ChangePlanOverlay }: any) => {
  if (!config.get('PADDLE_ENABLED')) {
    window.location.assign('https://piwik.pro/pricing');
    return null;
  }
  return (
    <React.Suspense fallback={<Preloader />}>
      <ChangePlanOverlay />
    </React.Suspense>
  );
});
